import { useMemo } from 'react';
import { useCrmData } from '../../../contexts/CrmProviders';

export const useBillingData = () => {
    const { clientProfile, crmUsers, isLoading, subscription, subscriptionPlans, saveClientProfile } = useCrmData();

    const billingContact = useMemo(() => {
        if (!clientProfile) {
            return { name: 'N/A', initials: 'N/A', email: '' };
        }

        const nameParts = clientProfile.name.split(' ');
        const initials = nameParts.length > 1
            ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
            : nameParts[0].substring(0, 2);

        return {
            name: clientProfile.name,
            initials: initials.toUpperCase(),
            email: clientProfile.email,
        };
    }, [clientProfile]);
    
    const consistentSubscription = useMemo(() => {
        if (!subscription || !subscriptionPlans) return subscription;

        const currentPlanFromList = subscriptionPlans.find(p => p.name === subscription.planName);
        if (currentPlanFromList) {
            return {
                ...subscription,
                pricePerSeat: parseFloat(currentPlanFromList.price.replace(',', '.'))
            };
        }
        
        return subscription; // Fallback to original subscription data if not found
    }, [subscription, subscriptionPlans]);


    return {
        clientProfile,
        subscription: consistentSubscription,
        subscriptionPlans,
        billingContact,
        isLoading,
        saveClientProfile
    };
};
